export enum ReportModalTypes {
  REPORT_CREATING = 'REPORT_CREATING',
  REPORT_CREATING_MDS = 'REPORT_CREATING_MDS',
  REPORT_DELETING = 'REPORT_DELETING',
  CD_REPORT_DELETING = 'CD_REPORT_DELETING',
  COLUMN_EDIT = 'COLUMN_EDIT',
  CREATE_CALCULATION = 'CREATE_CALCULATION',
  CREATE_BASIC_CALCULATION = 'CREATE_BASIC_CALCULATION',
  CREATE_CONDITIONAL = 'CREATE_CONDITIONAL',
  SAVED_VIEW_CREATING = 'SAVED_VIEW_CREATING',
  DIMENSIONAL_SAVED_VIEW_CREATING = 'DIMENSIONAL_SAVED_VIEW_CREATING',
  SAVED_VIEW_DELETING = 'SAVED_VIEW_DELETING',
  REPORT_EXPORT = 'REPORT_EXPORT',
  COLOR_CONTROLS = 'COLOR_CONTROLS',
  SET_TARGET = 'SET_TARGET',
  REPORT_SHARE = 'REPORT_SHARE',
  MANAGE_ACCESS = 'MANAGE_ACCESS',
  MANAGE_ACCESS_CD = 'MANAGE_ACCESS_CD',
  TEMPLATIZE = 'TEMPLATIZE',
  COPY_REPORT = 'COPY_REPORT',
  CD_COPY_REPORT = 'CD_COPY_REPORT',
  EDIT_CONTROL_BLOCK = 'EDIT_CONTROL_BLOCK'
}
